// list & single
export const getFundingIsFetching = state => state.fundingReducer.isFetching;
export const getFundingError = state => state.fundingReducer.error;

// list
export const getFunding = state => state.fundingReducer.funding;

// single
export const getSingleFunding = (state, id) => state.fundingReducer.funding[id];
